define('controllers/Podio.Controllers.FeatureTour',['require','jquery','underscore','translate','views/feature_tour/Podio.Views.FeatureTourMain','lib/Podio.UI.SimpleBalloon','models/Podio.Models.User','lib/backbone/Backbone.PodioController','lib/Podio.Config','lib/Podio.Event','lib/Podio.Routes','lib/Podio.UI','lib/Podio.Bootstrap','jst!feature_tour/_completed_balloon'],function(require) {

  var $ = require('jquery');
  var _ = require('underscore');
  var t = require('translate');
  var FeatureTourMainView = require('views/feature_tour/Podio.Views.FeatureTourMain');
  var SimpleBalloon = require('lib/Podio.UI.SimpleBalloon');
  var UserModel = require('models/Podio.Models.User');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var podioConfig = require('lib/Podio.Config');

  var podioEvent = require('lib/Podio.Event');
  var routes = require('lib/Podio.Routes');
  var podioUI = require('lib/Podio.UI');
  var bootstrap = require('lib/Podio.Bootstrap');

  var jstCompletedBalloon = require('jst!feature_tour/_completed_balloon');

  return PodioController.extend({

    initialize: function() {
      this._super();
      this.bindEvents();

      this.settings = bootstrap.getBootstrapData('FeatureTourSettings') || {};

      if (!_.isEmpty(this.settings)) {
        this.featureTourName = this.settings.name;
        this.promotionId = this.settings.promotionId;

        this.userModel = new UserModel();

        if (this.settings.pop && !this.settings.delayedStart) {
          this.initTour();
        }
      }
    },

    bindEvents: function() {
      this.eventBus.bind('featureTour:tourCompleted', this.onTourCompleted, this);
      this.eventBus.bind('featureTour:tourClosed', this.onTourClosed, this);
      this.eventBus.bind('featureTour:beforeShowStep', this.onBeforeShowTour, this);
      this.eventBus.bind('featureTour:persistTourClosed', this.onPersistTourClosed, this);
    },

    initTour: function() {
      var translations = {
        closeTour: {
          title: t('Repeat tour title #featuretour'),
          description: t('Repeat tour description #featuretour')
        },
        tasks_video: t('Managing your tasks #global_help_menu.video'),
        notifications_video: t('Managing your inbox notifications #global_help_menu.video')
      };

      var onboardingTranslations = {
        construction: {
          workspaces: {
            title: t('Construction vertical workspaces title #onboardingtour'),
            description: t('Construction vertical workspaces description #onboardingtour')
          },
          apps: {
            title: t('Construction vertical apps title #onboardingtour'),
            description: t('Construction vertical apps description #onboardingtour')
          },
          items: {
            title: t('Construction vertical items title #onboardingtour'),
            description: t('Construction vertical items description #onboardingtour')
          }
        },
        legal: {
          workspaces: {
            title: t('Legal vertical workspaces title #onboardingtour'),
            description: t('Legal vertical workspaces description #onboardingtour')
          },
          apps: {
            title: t('Legal vertical apps title #onboardingtour'),
            description: t('Legal vertical apps description #onboardingtour')
          },
          items: {
            title: t('Legal vertical items title #onboardingtour'),
            description: t('Legal vertical items description #onboardingtour')
          }
        },
        accounting: {
          workspaces: {
            title: t('Accounting vertical workspaces title #onboardingtour'),
            description: t('Accounting vertical workspaces description #onboardingtour')
          },
          apps: {
            title: t('Accounting vertical apps title #onboardingtour'),
            description: t('Accounting vertical apps description #onboardingtour')
          },
          items: {
            title: t('Accounting vertical items title #onboardingtour'),
            description: t('Accounting vertical items description #onboardingtour')
          }
        },
        manufacturing: {
          workspaces: {
            title: t('Manufacturing vertical workspaces title #onboardingtour'),
            description: t('Manufacturing vertical workspaces description #onboardingtour')
          },
          apps: {
            title: t('Manufacturing vertical apps title #onboardingtour'),
            description: t('Manufacturing vertical apps description #onboardingtour')
          },
          items: {
            title: t('Manufacturing vertical items title #onboardingtour'),
            description: t('Manufacturing vertical items description #onboardingtour')
          }
        },
        realestate: {
          workspaces: {
            title: t('Real Estate vertical workspaces title #onboardingtour'),
            description: t('Real Estate vertical workspaces description #onboardingtour')
          },
          apps: {
            title: t('Real Estate vertical apps title #onboardingtour'),
            description: t('Real Estate vertical apps description #onboardingtour')
          },
          items: {
            title: t('Real Estate vertical items title #onboardingtour'),
            description: t('Real Estate vertical items description #onboardingtour')
          }
        },
        horizontal: {
          workspaces: {
            title: t('Horizontal vertical workspaces title #onboardingtour'),
            description: t('Horizontal vertical workspaces description #onboardingtour')
          },
          apps: {
            title: t('Horizontal vertical apps title #onboardingtour'),
            description: t('Horizontal vertical apps description #onboardingtour')
          },
          items: {
            title: t('Horizontal vertical items title #onboardingtour'),
            description: t('Horizontal vertical items description #onboardingtour')
          }
        }
      };

      var userprops = podioConfig.user.properties.user_segmentation || {};
      var onboarding_key = userprops.industry || '';

      translations.onboarding = onboardingTranslations[onboarding_key.toLowerCase()] || onboardingTranslations.horizontal;
      translations.onboarding.settings = {
        title: t('Item settings title #onboardingtour'),
        description: t('Item settings description #onboardingtour')
      };

      this.mainTourView = new FeatureTourMainView({
        eventBus: this.eventBus,
        featureTourName: this.featureTourName,
        closeable: this.settings.closeable,
        startingStep: this.settings.startingStep,
        translations: translations
      });

      this.mainTourView.gatherSteps();
      this.mainTourView.startTour();
    },

    onTourCompleted: function() {
      this.mainTourView.closeTour();
    },

    onTourClosed: function() {

      // Balloon
      this.tourCompletedBalloon = new SimpleBalloon({
        elmAttachmentTarget: $('.podio-help'),
        content: this.getTemplate(jstCompletedBalloon, this.mainTourView.translations.closeTour)
      });

      this.tourCompletedBalloon.render();

      // Transfer effect
      this.mainTourView.elmStep.effect( 'transfer', { to: this.tourCompletedBalloon.elm }, 500 );

      // More balloon
      this.tourCompletedBalloon.fadeIn();
      this.tourCompletedBalloon.fadeOut(5000);

      // Persist
      this._persistTourClosed();

      // Trigger global event to signal that the feature tour was closed
      podioEvent.trigger(podioEvent.Types.featureTourClosed);
    },

    onBeforeShowTour: function(step) {
      // This is a hack to make trigger custom logic on specfic tour steps
      if ( this.featureTourName === 'tasks' && step.number.toString() === '2' ) {
        var elmTaskText = $('#task_text');
        elmTaskText.val( t('This is a test task #featuretour') );
        elmTaskText.trigger('keyup');
      }
    },

    onPersistTourClosed: function() {
      var dfd = this._persistTourClosed();
      dfd.done(this.mainTourView.tourClosePersisted);
    },

    _persistTourClosed: function() {
      if (this.promotionId) {
        var context_ref;
        if (podioUI.context()) {
          context_ref = {
            context_ref_type: podioUI.context().context_type,
            context_ref_id: podioUI.context().context_id
          };
        }

        return this.request('delete', routes.promotion_path(this.promotionId, context_ref));
      } else {
        var dfd = new $.Deferred();
        return dfd.resolve();
      }
    }
  });


});

